export default {
  /**
   * 检测表单框是否必填
   * bool = true / false
   */
  handleMust(bool) {
    if (bool) {
      return 'ant-form-item-required'
    }
    return ''
  },

  /**
   * 存储空间 - 存值
   * key = 名称
   * value = 内容
   */
  storageSet(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  /**
   * 存储空间 - 查值
   * key = 名称
   */
  storageGet(key) {
    return JSON.parse(localStorage.getItem(key))
  },
  /**
   * 存储空间 - 删值
   * key = 名称
   */
  storageDel(key) {
    localStorage.removeItem(key)
  },

  /**
   * 密码强度
   * value = string
   */
  passStrength(value) {
    let modes = 0
    // 正则表达式验证符合要求的
    if (value.length < 1) return modes
    if (/\d/.test(value)) modes++ // 数字
    if (/[a-z]/.test(value)) modes++ // 小写
    if (/[A-Z]/.test(value)) modes++ // 大写
    if (/\W/.test(value)) modes++ // 特殊字符
    // 逻辑处理
    switch (modes) {
      case 4:
        return value.length < 4 ? 3 : 4
      default:
        return modes
    }
  },

  /**
   * 密码强度文字说明
   */
  passText() {
    let text = ''
    switch (window.Global.pwDifficulty) {
      case 1: text = '密码最少8位，最大20位，密码包含 数字 或者 英文'; break
      case 2: text = '密码最少8位，最大20位，密码必须包含 数字和英文（不区分大小写）'; break
      case 3: text = '密码最少8位，最大20位，密码必须包含 数字和英文大小写'; break
      default: text = '密码最少8位，最大20位，密码包含 数字、英文大小写、特殊符号混合 @ # $ % & * . = + -'
    }
    return text
  },

  /**
   * 文件大小转换
   * size = number
   * type = size是什么单位（1 = KB, 2 = 字节）
   */
  sizeTurn(size, type = 1) {
    // 先处理成KB
    if (type === 2) {
      size = size / 1024
    }
    let kb = 1024
    let mb = 1024 * kb
    let gb = 1024 * mb
    let New = ''
    if (size < kb) {
      return (size % 1 === 0) ? size + ' KB' : size.toFixed(2) + ' KB'
    } else if (size < mb) {
      New = size / kb
      return (New % 1 === 0) ? New + ' MB' : New.toFixed(2) + ' MB'
    } else if (size < gb) {
      New = size / mb
      return (New % 1 === 0) ? New + ' GB' : New.toFixed(2) + ' GB'
    }
  },

  /**
   * 倒计时关闭加载
   * index = 下标
   * timeout = 执行时间
   */
  closeLoad(index, timeout = 1000) {
  },

  // /**
  //  * 时间戳格式化为yyyy-MM-dd
  //  * time = 时间戳
  //  */
  // timestampToYms (time) {
  //   let nowDate = new Date(time)
  //   let getMonth = parseInt(nowDate.getMonth() + 1)
  //   // 开始
  //   let year = nowDate.getFullYear()
  //   let month = (getMonth > 9) ? getMonth : '0' + getMonth
  //   let date = (nowDate.getDate() > 9) ? nowDate.getDate() : '0' + nowDate.getDate()
  //   return year + '-' + month + '-' + date
  // },
  // /**
  //  * 时间戳格式化为yyyy-MM-dd hh:mm:ss格式
  //  * time = 时间戳
  //  */
  // timestampToYmsHis (time) {
  //   // 计算年月日时分的函数
  //   let date = new Date(time)
  //   let Y = date.getFullYear() + '-'
  //   let M = (date.getMonth() + 1) + '-'
  //   let D = date.getDate() + ' '
  //   let h = date.getHours() + ':'
  //   let m = date.getMinutes() + ':'
  //   let s = date.getSeconds()
  //   return Y + M + D + h + m + s
  // },
  // /**
  //  * 时间戳格式化为 2022年4月20日10:26:32星期三
  //  * time = 时间戳
  //  */
  // timestampToArray(time) {
  //   //获取当前时间
  //   let myDate = new Date(time)
  //   let wk = myDate.getDay()
  //   let yy = String(myDate.getFullYear())
  //   let mm = myDate.getMonth() + 1
  //   let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
  //   let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
  //   let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
  //   let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
  //   let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  //   let week = weeks[wk]
  //   this.nowDate = yy + '年' + mm + '月' + dd + '日'
  //   this.nowTime = hou + ':' + min + ':' + sec
  //   this.nowWeek = week
  //   return [this.nowDate, this.nowTime, this.nowWeek]
  // },

  /**
   * 字符串判断
   * text = string
   */
  pathUrl(text) {
    const prefix = text.split('://')
    if (prefix[0] === 'http' || prefix[0] === 'https') {
      return text
    } else {
      return window.Global.siteUrl + text
    }
  },

  /**
   * table列表处理
   * prop = 字符串 / 数组
   * items = 值
   * type = (text / img)
   */
  handleProp(prop, items, type = 'text') {
    let model = ''
    if (typeof prop === 'string') {
      model = items[prop]
    } else {
      // 根据层级取值
      switch (prop.length) {
        case 2:
          model = items[prop[0]] !== null && items[prop[0]] !== undefined ? items[prop[0]][prop[1]] : ''
          break
        case 3:
          if (items[prop[0]] !== null && items[prop[0]] !== undefined) {
            if (items[prop[0]][prop[1]] !== null && items[prop[0]][prop[1]] !== undefined) {
              model = items[prop[0]][prop[1]][prop[2]]
            }
          }
          break
        default:
          if (items[prop[0]] !== null && items[prop[0]] !== undefined) {
            if (items[prop[0]][prop[1]] !== null && items[prop[0]][prop[1]] !== undefined) {
              if (items[prop[0]][prop[1]][prop[2]] !== null && items[prop[0]][prop[1]][prop[2]] !== undefined) {
                model = items[prop[0]][prop[1]][prop[2]][prop[3]]
              }
            }
          }
      }
    }
    // 判断前缀是否是 http
    if (type === 'text') {
      return model !== '' ? model : ''
    } else {
      if (model) {
        const prefix = model.split('://')
        if (prefix[0] === 'http' || prefix[0] === 'https') {
          return model !== '' ? model : ''
        } else {
          return model !== '' ? window.Global.siteUrl + model : ''
        }
      } else {
        return model
      }
    }
  },

  /**
   * 展示数据结构 (表单使用)
   * forms = 数据结构
   * res = 值
   */
  showForms(forms, res) {
    forms.forEach((items) => {
      if (items.style === 'forms') {
        // 表单结构
        items.array.forEach((value) => {
          value.model = this.showProp(value, value.prop, res)
        })
      } else if (items.style === 'file' || items.style === 'annex') {
        // 判断有没有设置取值名称
        if (res[items.prop] !== undefined && res[items.prop] !== null && res[items.prop] !== '') {
          // 判断类型是否为数组
          if (res[items.prop].constructor === Array) {
            items.model = res[items.prop]
          } else {
            items.model = [res[items.prop]]
          }
        } else {
          items.model = []
        }
      } else if (items.style === 'grouping' || items.style === 'grouped') {
        items.array.forEach((value) => {
          // 判断有没有设置取值名称
          if (res[value.prop] !== undefined && res[value.prop] !== null && res[value.prop] !== '') {
            // 判断类型是否为数组
            if (res[value.prop].constructor === Array) {
              value.model = res[value.prop]
            } else {
              value.model = [res[value.prop]]
            }
          } else {
            value.model = []
          }
        })
      } else if (items.style === 'maps') {
        // 腾讯地图坐标 maps
        items.model = this.showProp(items, items.prop, res)
        items.model2 = this.showProp(items, items.prop2, res)
        items.model3 = this.showProp(items, items.prop3, res)
      } else if (items.style === 'ckeditor') {
        // 编辑器类型 ckeditor
        items.model = this.showProp(items, items.prop, res)
      }
    })
    return forms
  },
  /**
   * 处理上面的结构
   * prop = 字符串 / 数组
   * items = 值
   */
  showProp(original, prop, items) {
    let model = ''
    if (typeof prop === 'string') {
      model = items[prop]
    } else {
      // 根据层级取值
      switch (prop.length) {
        case 1:
          model = items[prop[0]]
          break
        case 2:
          model = items[prop[0]][prop[1]]
          break
        case 3:
          model = items[prop[0]][prop[1]][prop[2]]
          break
        default:
          model = items[prop[0]][prop[1]][prop[2]][prop[3]]
      }
    }
    return (model !== null && model !== undefined) ? model : original.model
  },

  /**
   * 发送数据结构
   * forms = 数据结构
   */
  sendForms(forms) {
    let arrayHandle = {}
    forms.forEach((items) => {
      if (items.style === 'forms') {
        // 表单结构
        items.array.forEach((value) => {
          this.sendProp(value, arrayHandle)
        })
      } else if (items.style === 'file') {
        // 是否有设置传递值
        let prop = items.deliver === undefined ? items.prop : items.deliver
        if (items.limit === 1) {
          arrayHandle[prop] = (items.model.length > 0) ? items.model[0] : ''
        } else {
          arrayHandle[prop] = items.model
        }
      } else if (items.style === 'grouping' || items.style === 'grouped') {
        items.array.forEach((value) => {
          // 是否有设置传递值
          let prop = value.deliver === undefined ? value.prop : value.deliver
          if (items.limit === 1) {
            arrayHandle[prop] = (value.model.length > 0) ? value.model[0] : ''
          } else {
            arrayHandle[prop] = value.model
          }
        })
      } else if (items.style === 'maps') {
        // 腾讯地图坐标 maps
        arrayHandle[items.prop] = items.model
        arrayHandle[items.prop2] = items.model2
        arrayHandle[items.prop3] = items.model3
      } else {
        // 编辑器类型 ckeditor
        this.sendProp(items, arrayHandle)
      }
    })
    return arrayHandle
  },
  /**
   * 处理上面的结构
   * value = 字符串 / 数组
   * arrayHandle = 值
   */
  sendProp(value, arrayHandle) {
    // 如果该值不等于true 就不需要处理
    if (value.show !== undefined) {
      if (value.show === false) {
        return ''
      }
    }
    // 是否有设置传递值
    let prop = value.deliver === undefined ? value.prop : value.deliver
    // 判断类型
    if (typeof prop === 'string') {
      console.log(value.model);
      arrayHandle[prop] = value.model
    } else {
      // 根据层级取值
      switch (prop.length) {
        case 1:
          arrayHandle[prop[0]] = value.model
          break
        case 2:
          // 不存在就创建
          if (arrayHandle[prop[0]] === undefined) { arrayHandle[prop[0]] = {} }
          // 赋值
          arrayHandle[prop[0]][prop[1]] = value.model
          break
        case 3:
          // 不存在就创建
          if (arrayHandle[prop[0]] === undefined) { arrayHandle[prop[0]] = {} }
          if (arrayHandle[prop[0]][prop[1]] === undefined) { arrayHandle[prop[0]][prop[1]] = {} }
          // 赋值
          arrayHandle[prop[0]][prop[1]][prop[2]] = value.model
          break
        default:
          // 不存在就创建
          if (arrayHandle[prop[0]] === undefined) { arrayHandle[prop[0]] = {} }
          if (arrayHandle[prop[0]][prop[1]] === undefined) { arrayHandle[prop[0]][prop[1]] = {} }
          if (arrayHandle[prop[0]][prop[1]][prop[2]] === undefined) { arrayHandle[prop[0]][prop[1]][prop[2]] = {} }
          arrayHandle[prop[0]][prop[1]][prop[2]][prop[3]] = value.model
      }
    }
    console.log(arrayHandle);
    return arrayHandle
  },
  // 处理新增时的表单
  groupByTimestamp(inputObject, duplicateKeys) {
    const resultArray = [];
    const tempObject = {};

    for (const key in inputObject) {
      if (duplicateKeys.includes(key.split(/\d+$/)[0])) {
        const match = key.match(/(\d+)$/);
        if (match) {
          const timeStamp = match[0];
          if (!tempObject[timeStamp]) {
            tempObject[timeStamp] = {};
          }
          const newKey = key.split(/\d+$/)[0];
          tempObject[timeStamp][newKey] = inputObject[key];
        } else {
          if (!tempObject['noTimestamp']) {
            tempObject['noTimestamp'] = {};
          }
          tempObject['noTimestamp'][key] = inputObject[key];
        }
      }
    }

    for (const timeStamp in tempObject) {
      if (timeStamp !== 'noTimestamp') {
        resultArray.push(tempObject[timeStamp]);
      }
    }

    return resultArray;
  },
  // 处理数据回显的表单
  transformObject(key, obj) {
    let newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key];
    }
    if (key in obj) {
      obj.gifts.forEach((gift, index) => {
        for (let giftKey in gift) {
          newObj[`${giftKey}${index}`] = gift[giftKey];
        }
      });
    }
    return newObj;
  }
}



// WEBPACK FOOTER //
// ./src/components2/utils/methods.js